if (!customElements.get('accordion-menu')) {
  customElements.define(
    'accordion-menu',
    class AccordionMenu extends HTMLElement {
      constructor() {
        super();
        this.setCount()
      }

      connectedCallback() {
        this.trigger.addEventListener('click', this.onClick.bind(this))
      }

      disconnectedCallback() {
        this.trigger.removeEventListener('click', this.onClick.bind(this))
      }

      setCount() {
        const items = this.content.querySelectorAll('.js-item')
        this.style.setProperty('--items-count', (items?.length || 0))
      }

      onClick() {
        this.classList.toggle('active')
      }

      get trigger() {
        return this.querySelector('.js-trigger')
      }

      get content() {
        return this.querySelector('.js-content')
      }
    }
  );
}
